import { render, staticRenderFns } from "./myDonations.vue?vue&type=template&id=d64a3764&scoped=true"
import script from "./myDonations.vue?vue&type=script&lang=js"
export * from "./myDonations.vue?vue&type=script&lang=js"
import style0 from "./myDonations.vue?vue&type=style&index=0&id=d64a3764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64a3764",
  null
  
)

export default component.exports